export var radius = {
    basic: '2px',
    focus: '4px',
};
//# sourceMappingURL=radius.js.map